module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Back-69f5c9b7451b33ff9556cce41bfdce62.png";